import React, { useState } from "react";
import { Link } from "react-router-dom";

const NavigationMenu = ({ isOpen, setIsOpen }) => {
  const [showContactPopup, setShowContactPopup] = useState(false);

  const handleContactClick = (e) => {
    e.preventDefault();
    setShowContactPopup(true);
    setIsOpen(false);
  };

  const closeContactPopup = () => {
    setShowContactPopup(false);
  };

  return (
    <>
      <div className="navigation-menu">
        {/* Pas de hamburger — le logo dans LogoBlanc fait office de trigger */}

        <div className={`wrapper ${isOpen ? "active" : ""}`}>
          <ul className="Menu-list">
            <Link id="menu-link" to="/" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item main-item">ACCUEIL
                <span className="Mask"><span>ACCUEIL</span></span>
                <span className="Mask"><span>ACCUEIL</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/projets" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item main-item">PROJETS
                <span className="Mask"><span>PROJETS</span></span>
                <span className="Mask"><span>PROJETS</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/anhydran" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">An·hydra·n
                <span className="Mask"><span>An·hydra·n</span></span>
                <span className="Mask"><span>An·hydra·n</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/phonemes2" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Phonèmes#2
                <span className="Mask"><span>Phonèmes#2</span></span>
                <span className="Mask"><span>Phonèmes#2</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/phonemes1" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Phonèmes#1
                <span className="Mask"><span>Phonèmes#1</span></span>
                <span className="Mask"><span>Phonèmes#1</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/transmutation" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Transmutation
                <span className="Mask"><span>Transmutation</span></span>
                <span className="Mask"><span>Transmutation</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/flots" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Flots
                <span className="Mask"><span>Flots</span></span>
                <span className="Mask"><span>Flots</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/transcendance" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Transcendance
                <span className="Mask"><span>Transcendance</span></span>
                <span className="Mask"><span>Transcendance</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/tina" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">.T.I.N.A
                <span className="Mask"><span>.T.I.N.A</span></span>
                <span className="Mask"><span>.T.I.N.A</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/eveil" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Eveil
                <span className="Mask"><span>Eveil</span></span>
                <span className="Mask"><span>Eveil</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/recherche" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item main-item">RECHERCHE
                <span className="Mask"><span>RECHERCHE</span></span>
                <span className="Mask"><span>RECHERCHE</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/atlas-recherche" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Atlas de recherche
                <span className="Mask"><span>Atlas de recherche</span></span>
                <span className="Mask"><span>Atlas de recherche</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/laboratoire-symbiotique" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Laboratoire symbiotique
                <span className="Mask"><span>Laboratoire symbiotique</span></span>
                <span className="Mask"><span>Laboratoire symbiotique</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/chambre-ecoute1" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Chambre d'écoute#1
                <span className="Mask"><span>Chambre d'écoute#1</span></span>
                <span className="Mask"><span>Chambre d'écoute#1</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/chambre-ecoute2" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Chambre d'écoute#2
                <span className="Mask"><span>Chambre d'écoute#2</span></span>
                <span className="Mask"><span>Chambre d'écoute#2</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/chambre-ecoute-anhydran" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item sub-item">Chambre d'écoute d'An·hydra·n
                <span className="Mask"><span>Chambre d'écoute d'An·hydra·n</span></span>
                <span className="Mask"><span>Chambre d'écoute d'An·hydra·n</span></span>
              </li>
            </Link>

            <Link id="menu-link" to="/a-propos" onClick={() => setIsOpen(false)}>
              <li className="Menu-list-item main-item">À PROPOS
                <span className="Mask"><span>À PROPOS</span></span>
                <span className="Mask"><span>À PROPOS</span></span>
              </li>
            </Link>

            <a id="menu-link" href="#" onClick={handleContactClick}>
              <li className="Menu-list-item main-item">CONTACT
                <span className="Mask"><span>CONTACT</span></span>
                <span className="Mask"><span>CONTACT</span></span>
              </li>
            </a>
          </ul>
        </div>
      </div>

      {showContactPopup && (
        <div className="contact-popup-overlay" onClick={closeContactPopup}>
          <div className="contact-popup" onClick={(e) => e.stopPropagation()}>
            <div className="contact-header">
              <button className="close-contact-btn" onClick={closeContactPopup}>×</button>
              <h2 className="contact-title">Contact</h2>
            </div>
            <div className="contact-content">
              <div className="contact-grid">
                <div className="personal-info">
                  <div className="info-section">
                    <div className="info-item">
                      <span className="info-label">Identité</span>
                      <span className="info-value"><strong>Elise VOËT</strong></span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Pronoms</span>
                      <span className="info-value">elle/elle</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Naissance</span>
                      <span className="info-value">15/12/1995 à Lille</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Localisation</span>
                      <span className="info-value">Vit et travaille à Mer et Orléans</span>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-item">
                      <span className="info-label">Email</span>
                      <span className="info-value">
                        <a href="mailto:elise.voet@hotmail.fr" className="contact-link">elise.voet@hotmail.fr</a>
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Téléphone</span>
                      <span className="info-value">06 70 81 67 45</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Instagram</span>
                      <span className="info-value">
                        <a href="https://www.instagram.com/_elise_voet_/" target="_blank" className="contact-link">@_elise_voet_</a>
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Discord</span>
                      <span className="info-value">EliseVoët#0343</span>
                    </div>
                  </div>
                </div>
                <div className="activities-section">
                  <h3 className="activities-title">Activités</h3>
                  <div className="activity-item">
                    <div className="activity-indicator"></div>
                    <span className="activity-text">Artiste transdisciplinaire multimedia</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-indicator"></div>
                    <span className="activity-text">Chercheuse à l'ECOLAB de l'ESAD Orléans<br/>Programme "Edition, Media Design : quand les data deviennent forme"</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-indicator"></div>
                    <span className="activity-text">Enseignante à l'ESAD Orléans en installation numérique</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-indicator"></div>
                    <span className="activity-text">Médiatrice culturelle</span>
                  </div>
                  <div className="activity-item">
                    <div className="activity-indicator"></div>
                    <span className="activity-text">Guide conférencière</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NavigationMenu;